__webpack_require__.p = "/wp-content/themes/avaniaclinical-2025/dist/";